{
  "actionbar.actions": "Akce",
  "actionbar.actionsAvailable": "Dostupné akce.",
  "actionbar.clearSelection": "Vymazat výběr",
  "actionbar.selected": "Vybráno: { count }",
  "actionbar.selectedAll": "Vybráno vše",
  "actionbutton.pending": "čeká na vyřízení",
  "breadcrumbs.more": "Další položky",
  "button.pending": "čeká na vyřízení",
  "calendar.invalidSelection": "{selectedCount, plural, one {Vybrané datum není} other {Vybraná data nejsou}} k dispozici.",
  "combobox.loading": "Načítání...",
  "combobox.loadingMore": "Načítání dalších...",
  "combobox.noResults": "Žádné výsledky",
  "contextualhelp.help": "Nápověda",
  "contextualhelp.info": "Informace",
  "datepicker.endTime": "Konečný čas",
  "datepicker.startTime": "Počáteční čas",
  "datepicker.time": "Čas",
  "dialog.alert": "Výstraha",
  "dialog.dismiss": "Odstranit",
  "dropzone.replaceMessage": "Přetáhněte soubor k nahrazení",
  "inlinealert.informative": "Informace",
  "inlinealert.negative": "Chyba",
  "inlinealert.notice": "Varování",
  "inlinealert.positive": "Úspěch",
  "label.(optional)": "(volitelně)",
  "label.(required)": "(požadováno)",
  "listview.loading": "Načítání...",
  "listview.loadingMore": "Načítání dalších...",
  "menu.loading": "Načítání...",
  "menu.loadingMore": "Načítání dalších...",
  "menu.moreActions": "Další akce",
  "menu.noResults": "Žádné výsledky",
  "menu.unavailable": "Není k dispozici, rozbalením zobrazíte podrobnosti",
  "notificationbadge.indicatorOnly": "Nová aktivita",
  "notificationbadge.plus": "{notifications}+",
  "picker.loading": "Načítání...",
  "picker.loadingMore": "Načítání dalších...",
  "picker.placeholder": "Vybrat…",
  "picker.selectedCount": "{count, plural, =0 {Nevybrány žádné položky} one {Vybrána # položka} few {Vybrány # položky} other {Vybráno # položek}}",
  "sidepanel.collapse": "Sbalit postranní panel",
  "sidepanel.expand": "Rozbalit postranní panel",
  "slider.maximum": "Maximum",
  "slider.minimum": "Minimum",
  "table.cancel": "Zrušit",
  "table.drag": "Přetáhnout",
  "table.editCell": "Upravit buňku",
  "table.loading": "Načítání...",
  "table.loadingMore": "Načítání dalších...",
  "table.resizeColumn": "Změnit velikost sloupce",
  "table.save": "Uložit",
  "table.sortAscending": "Seřadit vzestupně",
  "table.sortDescending": "Seřadit sestupně",
  "tag.actions": "Akce",
  "tag.hideButtonLabel": "Zobrazit méně",
  "tag.noTags": "Žádný",
  "tag.showAllButtonLabel": "Zobrazit vše ({tagCount, number})",
  "toast.clearAll": "Smazat vše",
  "toast.collapse": "Sbalit",
  "toast.showAll": "Zobrazit vše",
  "treeview.loadingMore": "Načítání dalších..."
}
